// import { PageViewType } from '~/api/myTasks'
import { myTasksQueryOpts } from '~/api/myTasks'
import { lazyMsg } from '~/common/localizationUtils'
import { defineActionBar } from '~/components/v2/ResultsLayout/ActionBar/ActionBar.hook'
import { filter } from '~/components/v2/ResultsLayout/Filters/Filters'
import { defineFilters } from '~/components/v2/ResultsLayout/Filters/FiltersProvider'
import { defineListData } from '~/components/v2/ResultsLayout/ListQueryProvider/ListQueryProvider'
import { userRoles } from '~/work_order_list/types_enums'
import { UserPreferenceNamespace } from '~/api/userPreferences'
import { UserTaskStatus } from './types'
import { UserTaskPageTab } from './constants'

export const actionBarDef = defineActionBar({
  defaultView: UserTaskPageTab.MY_TASKS,
  searchPlaceholder: lazyMsg('tasks.search_bar.search_tasks'),
  views: [
    {
      value: UserTaskPageTab.MY_TASKS,
      label: lazyMsg('tasks.drawer.my_tasks.tab'),
      dataTestId: 'tasks-settings-mini-tab-my-tasks-btn'
    },
    { value: UserTaskPageTab.ALL, label: lazyMsg('common.ui.all'), dataTestId: 'tasks-settings-mini-tab-all-btn' }
  ],
  orderings: [
    { value: 'important', label: lazyMsg('common.ui.sort_by.important') },
    { value: 'category_az', label: lazyMsg('common.ui.sort_by.category_a_z') },
    { value: 'category_za', label: lazyMsg('common.ui.sort_by.category_z_a') }
  ]
} as const)

export const filtersDef = defineFilters(
  {
    is_pinned: filter.singleCheckbox({
      id: 'is_pinned',
      title: lazyMsg('common.ui.pinned'),
      defaultIsOpen: true,
      checkboxLabel: lazyMsg('common.ui.pinned')
    }),
    status: filter.checkboxList.asNumbers({
      id: 'status',
      title: lazyMsg('common.ui.current_status'),
      defaultIsOpen: true,
      options: [
        {
          text: lazyMsg('term.pending'),
          value: UserTaskStatus.Pending
        },
        {
          text: lazyMsg('term.overdue'),
          value: UserTaskStatus.Overdue
        },
        {
          text: lazyMsg('common.ui.cancelled'),
          value: UserTaskStatus.Cancelled
        },
        {
          text: lazyMsg('common.ui.completed'),
          value: UserTaskStatus.Completed
        }
      ]
    }),
    category_name: filter.checkboxList.asStrings({
      id: 'category_name',
      title: lazyMsg('term.category', { count: 99 }),
      defaultIsOpen: true,
      config: { containerMaxHeight: 650 },
      optionsFromApi: {
        isSearchable: false,
        url: '/api/v2/user_tasks/categories',
        transform: "results.{'id': key, 'text': label, 'value': key}[]"
      }
    }),
    location: filter.checkboxList.asNumbers({
      id: 'location',
      title: lazyMsg('term.location', { count: 1 }),
      config: { maxCheckableCount: 100, isVirtualized: true },
      optionsFromApi: {
        url: '/api/v2/work_sites',
        pageSize: 100,
        searchParamKey: 'name',
        transform: "results.{'id': id, 'text': name, 'value': id}[]"
      }
    }),
    assignee: filter.checkboxList.asNumbers({
      id: 'assignee',
      title: lazyMsg('term.assignees', { count: 2 }),
      allowedFor: [userRoles.All],
      defaultIsOpen: false,
      config: { containerMaxHeight: 600 },
      optionsFromApi: {
        pageSize: 100,
        searchParamKey: 'query',
        url: '/api/v2/employer/?is_deleted=&limit=25&offset=25',
        transform: "results.{'text':full_name, 'value':id}[]"
      }
    })
  },
  UserPreferenceNamespace.TASK_LIST
)

export const tasksListDataDef = defineListData({
  actionBarDef,
  filtersDef,
  queryOpts: myTasksQueryOpts
})
